module.exports = "https://r.zoocdn.com/_next/static/images/Coast_icon-078d4dae6ec0286bae94d79f2efd1a9a.png";